<template>
	<div class="funnel_steps_templates layout-row noscroll flex">
		<div class="templates-container layout-column flex noscroll">
			<input type="text" placeholder="Type to search a template..." class="main-search-input" style="max-width: 100%;"
			       v-model="search">
			<div class="templates scroll">
				<v-spinner v-if="loading" />

				<div :class="['item build_from_scratch_btn',{'status': activeItem===1}]"
						     @click="selectTemplate(1)">
							<div class="image">
								<inline-svg :src="require('@/assets/img/plus_circle_icon.svg')"/>
							</div>
							<div class="title">Build from scratch</div>
						</div>

						<div class="item" v-for="(item, index) in filteredTemplates" :key="item.id"
						     :class="{'status': activeItem === item.id}" @click="selectTemplate(item.id)">
							<div class="image">
								<img :src="item.thumbnail_url" alt="">
								<div class="badge" v-if="item.badge">
									<div class="icon">
										<inline-svg :src="item.badge"/>
									</div>
								</div>
							</div>
							<div class="title">{{ item.name }}</div>
						</div>
			</div>

		</div>
		<div class="template-preview flex-none layout-column noscroll">
			<div class="banner_sidebar scroll">
				<div class="right flex layout-column">
					<div class="flex layout-column flex-center">
						<div class="head"></div>
						<h1 v-if="template">{{ template.name }}</h1>
						<h1 v-else>Unknown funnel</h1>
					</div>
					<div class="steps-list" v-if="template && template.id>1">

						<v-spinner v-if="loadingSteps" />
						<div v-else class="step layout-row" v-for="step in steps" :key="step.id">
							<div class="img-container flex-none">
								<img class="" :src="step.thumbnail_hash" />
							</div>
							<div class="step-details flex layout-column">
								<span class="name">{{step.name}}</span>
								<span class="tag">
					        <img class="" :src="stepType(step.type).img" />
					        {{stepType(step.type).title}}</span>
							</div>
						</div>

					</div>
				</div>

				<div v-if="!template || template.id<=1" class="image empty">
					<div class="">
						<inline-svg :src="require('@/assets/img/plus_circle_icon.svg')"/>
					</div>
					<div class="title">Build from scratch</div>
				</div>
				<div class="content">
					<div class="title">{{ template?template.name:'Empty funnel' }}</div>
					<div class="name"><span>by</span> {{ template?template.author_name:'Funnelish team' }}</div>
					<div class="desc">{{ template?template.description:'' }}</div>
					<div class="tags" v-if="template">
						<div class="tag" v-for="(tag,index) in tags" :key="index">
							{{ tag }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"
import API from "@/api"
import stepTypes, {types} from "@/helpers/stepTypes";
import Loading from "@/components/Loading";
import VSpinner from "@/components/base/v-spinner";

export default {
	name: "Templates",
	components: {VSpinner, Loading},
	mixins: [API],
	data: function () {
		return {
			loading: false,
			search: '',
			activeItem: 1,
			loadingSteps: false,
			steps: [{},{},{},{}],
			templates: [
				{
					id: 1,
					name: 'Empty funnel',
					img: '',
					badge: '',
					author_name: 'None',
					description: 'Start building your funnel from scratch, you can add steps to it once created...',
					tags: 'empty funnel',
				},
			],
		};
	},
	computed: {
		notificationsOpen() {
			return this.$store.state.notificationsOpen;
		},
		filteredTemplates() {
			let ar = this.templates.filter(template => {
				return template.id > 1 && template.name.toLowerCase().includes(this.search.toLowerCase())
			})
			ar = ar.sort(function(a,b){
				return new Date(b.created_at) - new Date(a.created_at);
			});
			return ar;
		},
		template() {
			let list = this.templates.filter(template => {
				return template.id === this.activeItem;
			});
			if (list.length>0) return list[0];
			return this.templates[0];
		},
		tags() {
			let tags = this.template.tags;
			return tags ? tags.split(",").filter(x=>x) : [];
		},
	},
	methods: {
		stepType(id) {
			return stepTypes.find(x=>x.id===id) || stepTypes.find(x=>x.id===types.OTHER);
		},
		selectTemplate(itemId) {
			this.activeItem = parseInt(itemId);
			this.$emit('selected', this.template);

			this.loadSteps(this.template ? this.template.funnel_id || 0 : 0)
		},
		async loadSteps(funnelId) {
			try {
				this.loadingSteps = true;
				this.steps = [{},{},{},{}];
				this.steps = await this.api.wsteps.getTemplateSteps(funnelId);
			} catch (e) {
				this.$error(e);
			} finally {
				this.loadingSteps = false;
			}
		},
		async init() {
			try {
				this.loading = true;
				this.templates = [];
				this.templates = await this.api.wsteps.getFunnelTemplates();
				if(this.templates && this.templates.length)
					this.$emit('selected', this.templates[0]);
			} catch (e) {
				this.$error(e);
			} finally {
				this.loading = false;
			}
		}
	},
	created() {
		this.init();
	}
}
</script>

<style lang="scss" scoped>
.funnel_steps_templates {
	display: grid;
	grid-auto-flow: column;
	grid-template-columns: calc(100% - 300px) 300px;

	.template-preview {
		margin: 0;
		width: 300px;
		min-width: 300px;
		padding: 10px;
	}

	.templates-container {
		.main-search-input {
			margin: 15px 0;
		}
		.templates {
			padding: 15px;
			background: #FFFFFF;
			border: 1px solid $light-grey;
			border-radius: 12px;
			flex-direction: row;
			flex-wrap: wrap;
			position: relative;

			display: grid;
			grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
			grid-gap: 20px;
			margin-top: 20px;

			.item.build_from_scratch_btn {
				border: 1px dashed #C5C7D2;
				display: flex;
				flex-direction: column;
				justify-content: center;
				box-shadow: 0 5px 25px rgb(0 0 0 / 16%);

				.image {
					display: flex;
					align-items: center;
					justify-content: center;
				}

				.title {
					color: #636A7B;
				}

				&.status {
					border: 1px solid #4368E0;
				}
				&:hover {
					border: 1px solid #4368E0;
				}
			}

			.row .col {
				display: flex;
				flex-direction: column;
			}

			.item {
				flex: 1;
				cursor: pointer;
				transition: 0.15s all ease-in-out;
			}

			.row {
				display: flex;
				flex-wrap: wrap;
				margin-left: -15px;
				margin-right: -15px;
			}

			.row .col {
				width: 33.3333333%;
				min-width: 178px;
				padding-left: 15px;
				padding-right: 15px;
			}

			.item {
				border: none;
				border-radius: 5px;
				padding: 0;
				//min-width: 250px;
				//width: 250px;
				height: 200px;
				//max-width: 250px;
				max-height: 200px;
				display: flex;
				flex-direction: column;
				overflow: hidden;
				box-shadow: 0 5px 25px rgb(0 0 0 / 16%);

				&:hover {
					box-shadow: 0 5px 25px rgb(0 0 0 / 16%), 0 0 0 2px $sharp-blue;
				}
				&.status {
					box-shadow: 0 5px 25px rgb(0 0 0 / 16%), 0 0 0 2px $sharp-blue;
				}

				&:not(.build_from_scratch_btn) {
					.image {
						flex: 1;
					}
				}
				.image {
					overflow: hidden;
					position: relative;

					img {
						width: 100%;
						object-fit: cover;
					}

					.badge {
						position: absolute;
						left: 4px;
						bottom: 6px;
					}
				}

				.title {
					padding: 3px;
					font-weight: 500;
					font-size: 13px;
					line-height: 150%;
					text-align: center;
					letter-spacing: 0.02em;
					color: #252A32;
					margin-top: 2px;
					flex: none;
				}
			}

			// .templates .item
		}

		// .templates
	}
}


.right {
	display: flex;
	align-items: center;
	position: relative;
	justify-content: stretch;
	padding: 5px 0;
	border-radius: 0;
	margin: 0 -15px;
	h1 {
		font-size: 16px;
	}
	.steps-list {
		flex: 1;
		display: flex;
		flex-direction: column;
		width: 100%;
		min-height: 150px;
		.step {
			position: relative;
			width: 100%;
			padding: 0 10px;
			border-top: 1px solid #acbcf0;
			background: #f1f5fa;
			overflow: hidden;
			min-height: 40px;
			.step-details {
				padding: 5px 5px;
				margin: auto;
				.name {
					font-size: 12px;
					font-weight: 500;
					margin-bottom: 5px;
					width: 140px;
					white-space: nowrap;
					text-overflow: ellipsis;
					overflow: hidden;
				}
			}
			&:last-child {
				border-bottom: 1px solid #acbcf0;
			}
			.tag {
				white-space: nowrap;
				font-weight: normal;
				font-size: 9px;
				line-height: 150%;
				text-align: center;
				letter-spacing: 0.02em;
				color: #636A7B;
				padding: 3px 5px;
				border: 1px solid #E4E6F1;
				border-radius: 3px;
				width: fit-content;
				img {
					height: 15px;
					vertical-align: middle;
				}
			}
			.img-container {
				height: 50px;
				min-width: 100px;
				border: 1px solid rgba(66, 104, 223, 0.4);
				margin: 10px 10px 0;
				overflow: hidden;
				border-radius: 4px 4px 0 0;
				border-bottom: none;
				box-shadow: 0 5px 25px rgba(0, 0, 0, 0.16);
			}
			img {
				max-width: 100%;
				object-fit: cover;
			}
		}
	}
}

.funnel_steps_templates .top_info_box {
	top: 0;
}

.templates .row .col {
	display: flex;
	flex-direction: column;
}

.templates .item {
	flex: 1;
	cursor: pointer;
	transition: 0.15s all ease-in-out;
}

.templates .item.build_from_scratch_btn .image {
	display: flex;
	align-items: center;
	justify-content: center;
}

.templates .item.build_from_scratch_btn .title {
	color: #636A7B;
}

.templates .item.build_from_scratch_btn {
	border: 1px dashed #C5C7D2;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.templates .item.build_from_scratch_btn:hover {
	border: 1px solid #4368E0;
}

.template-preview .banner_sidebar {
	padding: 15px;
	background: #FFFFFF;
	border: 1px solid $sharp-blue;
	border-radius: 12px;


	.image {
		position: relative;
		width: 100%;
		border: 1px solid $grey;
		border-radius: 8px;
		height: 200px;
		overflow: hidden;
		&.empty {
			border: 1px dashed #C5C7D2;
			display: flex;
			flex-direction: column;
			justify-content: center;
			text-align: center;
			align-items: center;
			.title {
				margin-top: 15px;
				font-size: 14px;
				color: #626b7a;
			}
		}
		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
		.badge {
			position: absolute;
			left: 14.5px;
			bottom: 12px;
		}
	}

	.content {
		height: auto;
		padding: 10px 0 0;

		.title {
			font-weight: 500;
			font-size: 15px;
			line-height: 150%;
			text-align: center;
			letter-spacing: 0.02em;
			color: #4368E0;
		}

		.name {
			font-weight: 500;
			font-size: 12px;
			line-height: 150%;
			letter-spacing: 0.02em;
			color: #C5C7D2;
			text-align: center;

			span {
				color: #252A32;
			}
		}

		.desc {
			margin-top: 10px;
			margin-bottom: 15px;
			font-weight: 500;
			font-size: 13px;
			line-height: 150%;
			letter-spacing: 0.02em;
			color: #636A7B;

			span {
				color: #252A32;
			}
		}

		.tags {
			display: flex;
			flex-wrap: wrap;
			margin-bottom: 10px;
		}

		.tag {
			font-size: 11px;
			line-height: 150%;
			text-align: center;
			letter-spacing: 0.02em;
			color: #252A32;
			padding: 2px 5px;
			background: #D5E5FF;
			border-radius: 4px;
			margin-bottom: 10px;
			margin-right: 10px;

			&:last-child {
				margin-left: 0;
			}
		}

		.btn {
			display: table;
			margin: 0 auto;
		}
	}

	// .content

}

</style>
